<template>
  <div>
    <div id="dropdown" />
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-col md:h-screen">
        <div class="flex flex-shrink-0">
          <div class="flex items-center justify-between px-6 py-2 bg-white border-b md:flex-shrink-0 md:w-56">
            <Link href="/">
              <img src="/images/logo_header.png">
            </Link>
          </div>
          <div class="md:text-md flex justify-end items-center p-4 w-full text-sm bg-white border-b md:px-12 md:py-0">
            <notifications />
            <chat-badge v-if="this.user.role === 1 || (this.user.role === 2 && this.user.professional.chat)" />
            <dropdown class="md:hidden" placement="bottom-end">
              <template #default>
                <svg class="w-6 h-6 fill-black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
              </template>
              <template #dropdown>
                <div class="mt-2 px-8 py-4 bg-blue-900 rounded shadow-lg">
                  <main-menu />
                </div>
              </template>
            </dropdown>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <main-menu :collapse="true" class="hidden flex-shrink-0 p-3 bg-blue-900 overflow-y-auto md:block" />
          <div class="flex flex-col w-full justify-between overflow-hidden">
            <div class="px-2 py-8 md:flex-1 md:p-6 md:overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200" scroll-region>
              <flash-messages />
              <slot />
              <modal-jitsi-meet ref="modalJitsiMeet" />
            </div>
            <div class="py-3 bg-gray-100 text-center text-gray-700">Copyright © {{ new Date().getFullYear() }}, MyHeart.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import ChatBadge from '@/Shared/Chat/ChatBadge'
import Notifications from './Notifications.vue'
import ModalJitsiMeet from '@/Shared/ModalJitsiMeet'

export default {
  provide() {
    return {
      //chat_users: this.chat_users,
      chat_users: () => computed(() => this.chat_users).value,
      openModalJitsi: this.openModalJitsi
    }
  },
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    MainMenu,
    ChatBadge,
    Notifications,
    ModalJitsiMeet,
},
  props: {
    auth: Object,
  },
  data() {
    return {
      chat_users: [],
    };
  },
  methods: {
    async loadChatUsers() {
      await fetch(
        `/chat/users`
      ).then(res => {
        res.json().then(json => {
          this.chat_users = json;
        });
      });
    },
    openModalJitsi(appointment) {
      this.$refs.modalJitsiMeet.openModalJitsi(appointment);
    }
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  mounted() {
    if(this.user.role === 1 || (this.user.role === 2 && this.user.professional.chat)) {
      this.loadChatUsers();
    }
  },
}
</script>
